export function safeSelect(obj: object, path: string): unknown {
  const parts = path.split(/\./g);
  let current: object | undefined = obj;

  while (current && parts.length) {
    const key = parts.shift();

    current = key ? (current as { [key]?: object })[key] : undefined;
  }

  return current;
}